// src/components/CurrentlyWorkingModal.jsx
// import React, { useEffect, useMemo, useState } from "react";
// import { AnimatePresence, motion } from "motion/react";
// import { Clock, X, LogOut, Coffee } from "lucide-react";

// function formatSeconds(s) {
//   if (s < 60) return `${s}s`;
//   const m = Math.floor(s / 60);
//   const r = s % 60;
//   return `${m}m ${r}s`;
// }

// export default function CurrentlyWorkingModal({ open, onClose }) {
//   const [elapsed, setElapsed] = useState(0);

//   const checkInTime = useMemo(() => {
//     const d = new Date();
//     return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
//   }, []);

//   useEffect(() => {
//     if (!open) return;
//     setElapsed(0);
//     const t = setInterval(() => setElapsed((v) => v + 1), 1000);
//     return () => clearInterval(t);
//   }, [open]);

//   return (
//     <AnimatePresence>
//       {open ? (
//         <motion.div
//           className="fixed inset-0 z-[70] flex items-center justify-center px-4"
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           role="dialog"
//           aria-modal="true"
//         >
//           <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />

//           <motion.div
//             className="relative w-full max-w-md rounded-2xl bg-white shadow-2xl border border-blue-200/60 overflow-hidden"
//             initial={{ opacity: 0, y: 18, scale: 0.98 }}
//             animate={{ opacity: 1, y: 0, scale: 1 }}
//             exit={{ opacity: 0, y: 12, scale: 0.98 }}
//             transition={{ type: "spring", stiffness: 260, damping: 22 }}
//           >
//             {/* header */}
//             <div className="p-5 pb-4 flex items-center gap-3">
//               <div className="h-10 w-10 rounded-xl bg-blue-50 flex items-center justify-center">
//                 <Clock className="h-5 w-5 text-blue-600" />
//               </div>
//               <div className="flex-1">
//                 <div className="text-xl font-bold text-blue-700">Currently Working</div>
//               </div>

//               <button
//                 type="button"
//                 onClick={onClose}
//                 className="h-9 w-9 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition"
//                 aria-label="Close"
//               >
//                 <X className="h-4 w-4 text-gray-600" />
//               </button>
//             </div>

//             {/* content */}
//             <div className="px-5 pb-5">
//               <div className="rounded-xl bg-gray-50 border border-gray-100 p-4 space-y-3">
//                 <div className="flex items-center justify-between text-sm">
//                   <span className="text-gray-500">Check-in time:</span>
//                   <span className="font-semibold text-blue-600">{checkInTime}</span>
//                 </div>

//                 <div className="flex items-center justify-between text-sm">
//                   <span className="text-gray-500">Time elapsed:</span>
//                   <span className="font-semibold text-blue-600">{formatSeconds(elapsed)}</span>
//                 </div>

//                 <div className="flex items-center justify-between text-sm">
//                   <span className="text-gray-500">Total work time:</span>
//                   <span className="font-semibold text-blue-600">{formatSeconds(elapsed)}</span>
//                 </div>
//               </div>

//               {/* actions */}
//               <div className="mt-5 flex gap-3">
//                 <button
//                   type="button"
//                   className="flex-1 h-11 rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-semibold shadow-sm transition inline-flex items-center justify-center gap-2"
//                 >
//                   <Coffee className="h-4 w-4" />
//                   Break
//                 </button>

//                 <button
//                   type="button"
//                   className="flex-1 h-11 rounded-xl bg-slate-800 hover:bg-slate-900 text-white font-semibold shadow-sm transition inline-flex items-center justify-center gap-2"
//                 >
//                   <LogOut className="h-4 w-4" />
//                   Check Out
//                 </button>
//               </div>
//             </div>
//           </motion.div>
//         </motion.div>
//       ) : null}
//     </AnimatePresence>
//   );
// }

import React from "react";
import { AnimatePresence, motion } from "motion/react";
import { X, LogOut, Coffee, Clock as ClockIcon } from "lucide-react";

const formatTime = (ts) => {
  if (!ts) return "--:--";
  return new Date(ts).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};

const fmt = (s) => {
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}m ${r}s`;
};

export default function CurrentlyWorkingModal({
  open,
  onClose,
  checkInAt,
  workSec,
  onBreak,
  onCheckOut,
}) {
  return (
    <AnimatePresence>
      {open ? (
        <>
          <motion.div
            className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[70]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />

          <motion.div
            className="fixed inset-0 z-[80] flex items-center justify-center px-4"
            initial={{ opacity: 0, scale: 0.96, y: 12 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.96, y: 12 }}
            transition={{ type: "spring", stiffness: 260, damping: 22 }}
          >
            <div
              className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl border border-slate-200 overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={onClose}
                className="absolute top-4 right-4 w-9 h-9 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center transition"
              >
                <X className="w-5 h-5 text-slate-500" />
              </button>

              <div className="p-6">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center">
                    <ClockIcon className="w-5 h-5 text-white" />
                  </div>
                  <h2 className="text-2xl font-bold text-blue-700">Currently Working</h2>
                </div>

                <div className="mt-5 bg-slate-50 rounded-xl p-4 border border-slate-200">
                  <div className="flex justify-between text-sm text-slate-600">
                    <span>Check-in time:</span>
                    <span className="font-semibold text-blue-700">{formatTime(checkInAt)}</span>
                  </div>

                  <div className="flex justify-between text-sm text-slate-600 mt-3">
                    <span>Time elapsed:</span>
                    <span className="font-semibold text-blue-700">{fmt(workSec)}</span>
                  </div>

                  <div className="flex justify-between text-sm text-slate-600 mt-3">
                    <span>Total work time:</span>
                    <span className="font-semibold text-blue-700">{fmt(workSec)}</span>
                  </div>
                </div>

                <div className="mt-6 grid grid-cols-2 gap-3">
                  <button
                    onClick={onBreak}
                    className="h-12 rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-semibold flex items-center justify-center gap-2 shadow-lg shadow-orange-500/20 transition"
                  >
                    <Coffee className="w-5 h-5" />
                    Break
                  </button>

                  <button
                    onClick={onCheckOut}
                    className="h-12 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-semibold flex items-center justify-center gap-2 shadow-lg shadow-slate-900/20 transition"
                  >
                    <LogOut className="w-5 h-5" />
                    Check Out
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        </>
      ) : null}
    </AnimatePresence>
  );
}